import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { SecurityValuationItem } from "../types";
import { loadSecurityValuation } from "../thunks/getSecurityValuationThunk";

export const useDisplaySecurityValuation = (
  symbol?: string
) => {
  const storeStatistics = useSelector<
    StoreType,
    SecurityValuationItem | undefined
  >((store) => store.data.reports.securityStatistics.displaySecurityValuation);

  const displayedValuation =
    storeStatistics && storeStatistics.symbol === symbol
      ? storeStatistics
      : undefined;

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (symbol) {
      dispatch(loadSecurityValuation( symbol));
    }
  }, [dispatch, symbol]);

  return displayedValuation;
};